<template>
  <div class="landing-wrapper df fdc aifs f1 w100p">

    <!-- <div class="top-bar-global w100p _position1 df jcsb aic breadcrumb-wrapper">
      <div class="breadcrumb df f1">
        <h2>Home</h2>
      </div>
    </div> -->


    <div v-if="($store.getters['AUTH.myPrivateData'].type == 'alpha') || ($store.getters['AUTH.myPrivateData'].type == 'pro')" class="whole-page-box-global-2 whole-page-box-global-2-bigger w100p mb20 df jcc">
      <div class="title-box df">
        <h3 class="title-right">Start a cupping session</h3>
        <h4 class="button-1" @click="newSession()">
            New Session
        </h4>
      </div>
    </div><div v-else class="whole-page-box-global-2 whole-page-box-global-2-bigger w100p mb20 df jcc">
      <div class="title-box df">
        <h3 class="title-right">Start scoring</h3>
        <h4 class="button-1" @click="goTo('/cupping')">
            </i>Go
        </h4>
      </div>
    </div>
    <div v-if="route.page == 'DashboardPostPage'" class="whole-page-box-global-2 whole-page-box-global-2-unset w100p mb0">
      <NewsPost/>
    </div>
    <div v-else class="whole-page-box-global-2 whole-page-box-global-2-unset _abc df fdc aifs w100p mb0">
      <p class="heading">What's happening around Cupwise</p>
      <NewsFeed/>
    </div>

  </div>
</template>

<script>

import router from '../router'
import LandingProduct from '@/components/LandingProduct'
import NewsFeed from '@/components/NewsFeed'
import NewsPost from '@/components/NewsPost'
// import AcceptCreditCard from '@/components/AcceptCreditCard'

export default {
  name: 'Dashboard',
  data () {
    return {
      loading: false,
      route: {}
    }
  },
  props: ['mode'],
  components: {
    LandingProduct,
    NewsFeed,
    NewsPost,
    // AcceptCreditCard
  },
  methods: {
    newSession (product) {
      this.goTo('/add/' + 'live-session')
    },
    goTo (route) {
      router.push(route)
    },
  },
  computed: {
  },
  watch: {
    $route (to, from) {
      if (to !== from) {
        this.route = {
          page: this.$route.name,
          postid: this.$route.params.postid
        }
      }
    }
  },
  created () {
    this.route = {
      page: this.$route.name,
      postid: this.$route.params.postid
    }
    console.log('* Landing page created', this.$route)
  }
}
</script>

<style scoped lang="scss">
  @import "../styles/settings.scss";

  .landing-wrapper {
    padding: 19px;
    padding-top: 0px;
  }
  .landing-splash, .landing-choose-your-feel {
    width: 100%;
    max-width: 720px;
  }
  .landing-products {
    flex-wrap: wrap;
    max-width: 860px;
  }
/*  iframe {
    width: 100%;
    height: 400px;
  }*/
  p {
    color: black; 
  }
  h3 {
    // color: #5C5C5C;
    font-family: Inter;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 20px;
    .icon {
      margin-right: 6px;
    }
  }

  .heading {
      color: #5C5C5C;
      font-family: Inter;
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 20px;
      margin-bottom: 30px;
      width: 100%;
      // margin-top: 20px;
  }
  .title-right {
    margin-right: 27px;
  }
  .mb0 {
    margin-bottom: 0;
  }
  .mb20 {
    margin-bottom: 20px;
  }
  .button-1 {
    min-width: 143px;
  }
  .title-box {
    flex: 1
  }
  ._abc {
    align-items: flex-start;
  }
  @media (max-width: 425px) {
    .whole-page-box-global-2-bigger {
      height: unset;
      padding-top: 30px;
      padding-bottom: 30px;
    }
    .title-right {
      text-align: center;
      margin-right: 0;
      margin-bottom: 15px;
    }
    .title-box {
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue